import { render, staticRenderFns } from "./registerFour.vue?vue&type=template&id=c76080d6&scoped=true&"
import script from "./registerFour.vue?vue&type=script&lang=js&"
export * from "./registerFour.vue?vue&type=script&lang=js&"
import style0 from "./registerFour.vue?vue&type=style&index=0&id=c76080d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76080d6",
  null
  
)

export default component.exports